var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FormLayout,{attrs:{"title":"Choose a location"},on:{"on-dismiss":_setup.handleDismiss}},[_c(_setup.VsWrapper,{staticClass:"px-5"},_vm._l((_vm.locationIds),function(id){return _c(_setup.LocationCard,{key:id,attrs:{"location-id":id,"link-to":{
        name: 'fvnext-info-panel',
        params: { id, source: 'locations' },
      }}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }